import type { FirstAccountSetupState } from "@cmmd-forge/contracts";

import { useCmmdForgeRuntimeListSnapshot } from "../../cmmd/cmmdForgeRuntimeListResource";
import { getCurrentForgeWorkspaceId } from "../../workspace/currentForgeWorkspaceStore";
import { shouldShowFirstAccountSetup } from "../../lib/firstAccountSetup";

export function useFirstAccountSetupRedirect(input: {
  readonly isAuthenticated: boolean;
  readonly pathname: string;
  readonly state: FirstAccountSetupState | null;
  readonly applyCloudEnvironmentGate: boolean;
}): boolean {
  const cloudCatalog = useCmmdForgeRuntimeListSnapshot({
    enabled: input.applyCloudEnvironmentGate,
  });
  if (input.state === null) {
    return false;
  }

  let hasEnvironmentId: boolean;
  if (!input.applyCloudEnvironmentGate) {
    hasEnvironmentId = true;
  } else if (cloudCatalog.isLoading) {
    hasEnvironmentId = true;
  } else {
    const currentWorkspaceId = getCurrentForgeWorkspaceId();
    if (currentWorkspaceId === null) {
      // Workspace not yet resolved: treat any existing environment as sufficient
      // to avoid sending every user to /setup on first load.
      hasEnvironmentId = cloudCatalog.environments.length > 0;
    } else {
      hasEnvironmentId = cloudCatalog.environments.some(
        (env) => env.cmmdOrganizationId === currentWorkspaceId,
      );
    }
  }

  return shouldShowFirstAccountSetup({
    isAuthenticated: input.isAuthenticated,
    pathname: input.pathname,
    state: input.state,
    hasEnvironmentId,
  });
}
